module.exports = __webpack_public_path__ + "static/img/guest51.83d5c25.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/guest51.png
// module id = 29sE
// module chunks = 0